import snakecaseKeys from 'snakecase-keys';
import { CosmosBaseV1Beta1Coin, InjectiveTokenFactoryV1Beta1Tx, } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
/**
 * @category Messages
 */
export default class MsgMint extends MsgBase {
    static fromJSON(params) {
        return new MsgMint(params);
    }
    toProto() {
        const { params } = this;
        const coin = CosmosBaseV1Beta1Coin.Coin.create();
        coin.denom = params.amount.denom;
        coin.amount = params.amount.amount;
        const message = InjectiveTokenFactoryV1Beta1Tx.MsgMint.create();
        message.sender = params.sender;
        message.amount = coin;
        if (params.receiver) {
            message.receiver = params.receiver;
        }
        return InjectiveTokenFactoryV1Beta1Tx.MsgMint.fromPartial(message);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/injective.tokenfactory.v1beta1.MsgMint',
            ...proto,
        };
    }
    toAmino() {
        const proto = this.toProto();
        const message = {
            ...snakecaseKeys(proto),
        };
        return {
            type: 'injective/tokenfactory/mint',
            value: message,
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/injective.tokenfactory.v1beta1.MsgMint',
            ...value,
        };
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/injective.tokenfactory.v1beta1.MsgMint',
            message: proto,
        };
    }
    toBinary() {
        return InjectiveTokenFactoryV1Beta1Tx.MsgMint.encode(this.toProto()).finish();
    }
}
